/**
 * Central help resources per screen. Vimeo ids are numeric strings from vimeo.com/{id}.
 * Documentation entries open in a new tab.
 */

export const HELP_PAGE_IDS = {
  documentsList: 'documentsList',
  scribeList: 'scribeList',
  patientSearch: 'patientSearch',
  outcomeTasks: 'outcomeTasks',
  referrals: 'referrals',
  insights: 'insights',
  workflows: 'workflows',
  clinics: 'clinics',
  admin: 'admin',
  user: 'user',
  config: 'config'
};

/** @type {Record<string, { modalTitle: string, videos?: { id: string, title: string }[], videosComingSoon?: boolean, documentation?: { title: string, url: string }[] }>} */
export const helpContentByPageId = {
  [HELP_PAGE_IDS.documentsList]: {
    modalTitle: 'Documents — help',
    videos: [
      { id: '1184341713', title: 'Browsing documents' },
      { id: '1184342563', title: 'Reviewing a document' },
      { id: '1184343097', title: 'Messaging patients' },
      { id: '1184343501', title: 'Writing transfer-of-care violation letters' }
    ],
    documentation: [
      {
        title: 'Documents List View (user guide)',
        url: 'https://docs.medgenixtech.co.uk/4-2-Documents-List-View-2da945b51fec8047b236d713d4b5e24d'
      },
      {
        title: 'Document Detail View (user guide)',
        url: 'https://docs.medgenixtech.co.uk/4-3-Document-Detail-View-2da945b51fec80b289bde865c9a70a70'
      }
    ]
  },
  [HELP_PAGE_IDS.scribeList]: {
    modalTitle: 'Scribe — help',
    videosComingSoon: true,
    documentation: [
      {
        title: 'Scribe List View (user guide)',
        url: 'https://docs.medgenixtech.co.uk/4-4-Scribe-List-View-3bb945b51fec8077b076ede67fcba81c'
      },
      {
        title: 'Scribe Detail View (user guide)',
        url: 'https://docs.medgenixtech.co.uk/4-5-Scribe-Detail-View-3bb945b51fec8011b7a4c1e87ac2059f'
      }
    ]
  },
  [HELP_PAGE_IDS.patientSearch]: {
    modalTitle: 'Patient search — help',
    documentation: [
      {
        title: 'Patient Search View (user guide)',
        url: 'https://docs.medgenixtech.co.uk/4-8-Patient-Search-3bc945b51fec80ae824ecc09ba50ea88'
      }
    ]
  },
  [HELP_PAGE_IDS.outcomeTasks]: {
    modalTitle: 'Outcome tasks — help',
    videos: [{ id: '1184343786', title: 'Outcome tasks' }],
    documentation: [
      {
        title: 'Outcome Tasks View (user guide)',
        url: 'https://docs.medgenixtech.co.uk/4-4-Outcome-Tasks-View-2da945b51fec80599b15d7d71eb28bac'
      }
    ]
  },
  [HELP_PAGE_IDS.referrals]: {
    modalTitle: 'Patient referrals — help',
    videos: [{ id: '1184345608', title: 'Patient referral tracker' }],
    documentation: [
      {
        title: 'Patient Referrals View (user guide)',
        url: 'https://docs.medgenixtech.co.uk/4-5-Patient-Referrals-View-32f945b51fec804cad63c17b16c394fa'
      }
    ]
  },
  [HELP_PAGE_IDS.insights]: {
    modalTitle: 'Insights — help',
    documentation: [
      {
        title: 'Insights View (user guide)',
        url: 'https://docs.medgenixtech.co.uk/4-6-Insights-View-2da945b51fec8040867dc93444a9f978'
      }
    ]
  },
  [HELP_PAGE_IDS.workflows]: {
    modalTitle: 'Workflows — help',
    videos: [{ id: '1184385179', title: 'Document workflow automations' }],
    documentation: [
      {
        title: 'Document Workflows View (user guide)',
        url: 'https://docs.medgenixtech.co.uk/4-7-Document-Workflows-View-346945b51fec809ebe6ee253fcbb3811'
      }
    ]
  },
  [HELP_PAGE_IDS.clinics]: {
    modalTitle: 'Clinic selector — help',
    documentation: [
      {
        title: 'Clinic Selector View (user guide)',
        url: 'https://docs.medgenixtech.co.uk/4-8-Clinic-Selector-View-32f945b51fec80919076f9d9f6c12c02'
      }
    ]
  },
  [HELP_PAGE_IDS.admin]: {
    modalTitle: 'Admin — help',
    videos: [
      { id: '1184373888', title: 'Managing users' },
      { id: '1184351369', title: 'Managing multi-clinic users' }
    ],
    documentation: [
      {
        title: 'Admin View (user guide)',
        url: 'https://docs.medgenixtech.co.uk/4-9-Admin-View-2da945b51fec801f9955c945470e0281'
      }
    ]
  },
  [HELP_PAGE_IDS.user]: {
    modalTitle: 'Your account — help',
    videos: [
      { id: '1184389656', title: 'Logging in and NHS care identity' }
    ],
    documentation: [
      {
        title: 'User View (user guide)',
        url: 'https://docs.medgenixtech.co.uk/4-10-User-View-2da945b51fec80bcb8bfc37f16003750'
      }
    ]
  },
  [HELP_PAGE_IDS.config]: {
    modalTitle: 'Configuration — help',
    documentation: [
      {
        title: 'Config View (user guide)',
        url: 'https://docs.medgenixtech.co.uk/4-11-Config-View-2da945b51fec80509188d07381765701'
      }
    ]
  }
};

export function getHelpContent(pageId) {
  return helpContentByPageId[pageId] || null;
}
